<script setup>
import { computed } from 'vue';
import { useDateFormat } from '@vueuse/core';
const props = defineProps({
  title: {
    type: String,
    default: () => '',
  },
  date: {
    type: String,
    default: () => '',
  },
  url: {
    type: String,
    default: () => '',
  },
});
const formattedDates = computed(() => {
  return useDateFormat(props.date, 'DD.MM.YYYY');
});
</script>
<template>
  <div
    :class="[
      'news-content',
      backgroundColor === 'black' ? 'white' : 'black',
      `news-content--${backgroundColor}`,
    ]"
  >
    <div class="news-content__top">
      <p class="mb-0 news-content__title promo-title" v-html="title"></p>
      <div
        class="news-content__description body-3-regular"
        v-html="description"
      ></div>
    </div>
    <div class="news-content__bottom">
      <div v-if="date" class="news-content__duration body-3-regular">
        {{ formattedDates }}
      </div>
      <Button v-slot="slotProps" as-child rounded>
        <CTagDetect
          :to="url"
          :class="slotProps.class"
          class="news-content__button button-black link-normal js-button-news-slide"
        >
          {{ $t('news.read_more') }}
        </CTagDetect>
      </Button>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.news-content {
  $parent: &;
  &--white {
    #{$parent} {
      &__description {
        background-color: $white;
        background-clip: content-box;
      }
    }
  }
  &--gray {
    #{$parent} {
      &__description {
        background-color: $gray;
        background-clip: content-box;
      }
    }
  }
  &--black {
    #{$parent} {
      &__description {
        background-color: rgba($surface-container-opacity, 0.5);
        background-clip: content-box;
      }
    }
  }
  &__top {
    @include media-breakpoint-up(md) {
      display: grid;
      grid-template-rows: 1fr 1fr;
      max-width: 33.8%;
      min-height: 368px;
      padding-right: 72px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 72);
      @include responsive-spacing(min-height, 368);
    }
  }
  &__title {
    text-align: center;
    @include media-breakpoint-up(md) {
      text-align: left;
    }
  }
  &__description {
    margin-top: 24px;
    text-align: center;
    &:deep(p:last-child) {
      margin: 0;
    }
    @include media-breakpoint-up(sm) {
      margin: 32px auto 0;
      max-width: 55%;
      min-height: 48px;
    }
    @include media-breakpoint-up(md) {
      margin: 0;
      max-width: unset;
      padding-top: 42px;
      text-align: left;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-top, 42);
      @include responsive-spacing(min-height, 48);
    }
  }
  &__bottom {
    align-items: center;
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(sm) {
      align-items: end;
      display: grid;
      gap: 24px;
      grid-template-columns: 3fr 6fr 3fr;
      margin-top: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(margin-top, 56);
      @include responsive-spacing(gap, 24);
    }
  }
  &__duration {
    margin-top: 16px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      margin-top: 0;
      text-align: left;
      &-time {
        white-space: nowrap;
      }
    }
  }
  &__button {
    margin-top: 24px;
    @include media-breakpoint-up(sm) {
      margin-top: 0;
      justify-self: center;
      width: fit-content;
    }
  }
}
</style>
